var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.25 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.25 13.25V22.1755",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8984 18.8246L33.2501 22.1762",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6017 18.8246L33.25 22.1762",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5469 24.9817V25.8196C26.5469 27.2072 27.6722 28.3334 29.0606 28.3334H37.4398C38.8282 28.3334 39.9535 27.2072 39.9535 25.8196V24.9817",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  }))));
};
export default SvgDownload;